/** @external {AbstractRequestAction} https://github.com/BenjaminVanRyseghem/switchless-redux-actions/blob/master/src/actions/api/abstractRequestAction.js */
/** @external {AbstractRSAAAction} https://github.com/BenjaminVanRyseghem/switchless-redux-actions/blob/master/src/actions/api/abstractRsaaAction.js */
import {
	AbstractRequestAction,
	AbstractRSAAAction
} from "../switchless-redux-actions";

/**
 * Success
 *
 * @constructor
 * @extends {AbstractRSAAAction}
 *
 * @param {Object} spec - Unused parameter
 * @param {Object} [my] - Protected properties holder
 */
export class Success extends AbstractRSAAAction {
	constructor() {
		super(...arguments); // eslint-disable-line prefer-rest-params

		/**
		 * Action type
		 * @type {string}
		 */
		this.type = "Success";
	}

	/**
	 * Flush the pending flag on success.
	 * @return {{pendingOperation: boolean}} New reducer state
	 */
	performNetworkReducer() {
		return { pendingOperation: false };
	}
}

/**
 * Failure
 *
 * @constructor
 * @extends {AbstractRSAAAction}
 *
 * @param {Object} spec - Unused parameter
 * @param {Object} [my] - Protected properties holder
 */
export class Failure extends AbstractRSAAAction {
	constructor() {
		super(...arguments); // eslint-disable-line prefer-rest-params

		/**
		 * Action type
		 * @type {string}
		 */
		this.type = "Failure";
	}

	/**
	 * Flush the pending flag on failure.
	 * @return {{pendingOperation: boolean}} New reducer state
	 */
	performNetworkReducer() {
		return { pendingOperation: false };
	}
}

/**
 * Request
 *
 * @extends {AbstractRSAAAction}
 *
 * @param {Object} spec - Unused parameter
 * @param {Object} [my] - Protected properties holder
 * @constructor
 */
export class Request extends AbstractRSAAAction {
	constructor() {
		super(...arguments); // eslint-disable-line prefer-rest-params

		/**
		 * Action type
		 * @type {string}
		 */
		this.type = "Success";
	}

	/**
	 * Set the pending flag on request.
	 * @return {{pendingOperation: boolean}} New reducer state
	 */
	performNetworkReducer() {
		return { pendingOperation: true };
	}
}

/**
 * Request action recording the network traffic.
 * Very useful to display a loader when a network request is going on.
 *
 *
 * @param {Object} spec - Action payload
 * @param {Object} [my={}] - Protected members holder
 * @constructor
 */
export class NetworkAction extends AbstractRequestAction {
	constructor() {
		super(...arguments); // eslint-disable-line prefer-rest-params

		/**
		 * Action type
		 * @type {string}
		 */
		this.type = "NetworkAction";

		/**
		 * Action options
		 * @type {object}
		 */

		this.options = {};

		/**
		 * Abstract endpoint to override in subclasses.
		 * @type {string}
		 * @protected
		 */
		this._endpoint = "NetworkAction/endpoints must be overridden";

		/**
		 * Action sub-actions
		 * @type {string}
		 * @protected
		 */
		this._actions = Object.assign({}, this._actions, {
			request: Request,
			success: Success,
			failure: Failure
		});
	}
}
